import { useMediaQuery } from '@material-ui/core';

/** Phones (portrait and landscape): below this the profile pages switch to their stacked, card-based layout. */
export const MOBILE_QUERY = '@media (max-width:760px)';

/** Whether the screen is phone sized. Evaluated on the first render so the page doesn't flash the desktop layout. */
export const useIsMobile = () => useMediaQuery(MOBILE_QUERY.replace('@media ', ''), {noSsr: true});
